import { View, Text, StyleSheet } from "react-native";
import { COLORS } from "../../theme/colors";

const ParkDetailsReviews = ({ ref, googleReviews }) => {
  return (
    <>
      {googleReviews?.reviews && (
        <View ref={ref} style={styles.detailsContainer}>
          <Text style={styles.detailsHeader} accessibilityRole="header">
            Reviews
          </Text>
          {googleReviews.reviews.map((review, index) => (
            <View key={`review-${review.author}-${index}`} style={styles.reviewContainer}>
              <View style={styles.reviewItemContainer}>
                <View style={styles.reviewHeader}>
                  <Text
                    style={styles.reviewName}
                    accessible={true}
                    accessibilityRole="text"
                    accessibilityLabel={`Reviewer name: ${review.author}`}
                  >
                    {review.author}
                  </Text>
                </View>
                <Text
                  style={styles.reviewComment}
                  accessible={true}
                  accessibilityRole="text"
                  accessibilityLabel={`Review comment: ${review.text}`}
                >
                  {review.text}
                </Text>
              </View>
              {index < googleReviews.reviews.length - 1 && <View style={styles.reviewDivider} />}
            </View>
          ))}
        </View>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  detailsContainer: {
    flexDirection: "column",
    marginTop: 20,
    paddingHorizontal: 15,
  },
  detailsHeader: {
    fontSize: 18,
    fontWeight: "bold",
    marginTop: 15,
    marginBottom: 8,
  },
  reviewContainer: {
    marginTop: 10,
  },
  reviewItemContainer: {
    flexDirection: "column",
    flex: 1,
    gap: 5,
  },
  reviewHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  reviewName: {
    fontSize: 16,
    fontWeight: "bold",
  },
  reviewComment: {
    marginTop: 14,
    fontSize: 14,
    lineHeight: 25,
  },
  reviewDivider: {
    height: 1,
    backgroundColor: COLORS.tertiary,
    marginVertical: 20,
  },
});

export default ParkDetailsReviews;
